export enum PAGE_TYPES {
  VOUCHER = "VOUCHER",
  PHYSICAL = "PHYSICAL",
}
